import { reportNationalNotesTypes } from './types';
import { newDate } from "helpers/dateTools";

const { SET_REPORT_NATIONAL_NOTES_FILTERS, RESTORE_INITIAL } = reportNationalNotesTypes;

const initialState = {
  ReportNationalNotes: [],
  startDate: newDate(),
  endDate: newDate(),
  station: null,
};

export const reportNationalNotesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_REPORT_NATIONAL_NOTES_FILTERS:
      return {
        ...state,
        [payload.key]: payload.value
      }
    case RESTORE_INITIAL:
      return initialState

    default:
      return state;
  }
};